export const REGEX = {
  PLUS_NUMBERS: /^\+?\d*$/,
  ONLY_NUMBERS: /^\d*$/,
};
